import type { DocumentType } from 'app-components/flux/storage/types';

export const isPdfMimeType = (mimeType?: string): boolean => mimeType?.toLowerCase() === 'application/pdf';

export const getReceiptImageUrl = (document?: DocumentType, mimeType?: string): string | undefined => {
  if (isPdfMimeType(mimeType) || isPdfMimeType(document?.mimeType)) {
    return document?.artifacts?.find(
      (artifact) => artifact.type === 'THUMBNAIL' && artifact.status === 'COMPLETE' && artifact.downloadUrl,
    )?.downloadUrl;
  }

  return document?.url;
};
